import { NotifyHelper } from "../../../helpers/toast";
import { eDmEmailConfigDefine } from "../../action-types/email/IDmEmailConfigActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const dmEmailConfigAction = {
    ...generateActions(eDmEmailConfigDefine, "EMAIL_CONFIG"),
    ...generateActionForKey(eDmEmailConfigDefine, "EMAIL_CONFIG",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(eDmEmailConfigDefine, "EMAIL_CONFIG",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(eDmEmailConfigDefine, "EMAIL_CONFIG",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(eDmEmailConfigDefine, "EMAIL_CONFIG",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(eDmEmailConfigDefine, "EMAIL_CONFIG",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}